import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import Quill from 'vue-quill-editor'

Vue.use(Quill)
Vue.use(VueQuillEditor)